import { FunctionComponent } from 'react';
import { IconHandler } from '.';
import { LabelValueType } from '../types';
import classNames from 'classnames';

const LabelValue: FunctionComponent<LabelValueType> = ({
  label,
  value,
  icon = null,
  iconSize,
  centered = false,
  boldValue = false,
  valueFirst = false,
  mutedIcon = false,
  noText = false,
  className = '',
}) => {
  return noText ? (
    <div
      title={label}
      className={` d-flex ${centered ? 'flex-column justify-content-center' : ''} align-items-center ${
        boldValue ? 'fw-bold' : 'fw-lighter'
      } ${className}`}
    >
      {icon && (
        <IconHandler
          Icon={icon}
          size={iconSize ? iconSize : centered && !noText ? '1.2rem' : '1rem'}
          className={classNames('d-flex', centered ? '' : 'me-2', mutedIcon ? 'text-muted' : '')}
        />
      )}
      {value}
    </div>
  ) : (
    <div
      className={`${boldValue ? '' : 'fw-bold'} p-0 ${
        centered ? 'justify-content-center text-center' : 'd-flex d-md-inline-flex align-items-center'
      } ${className}`}
    >
      <div className={`${centered ? 'd-flex justify-content-center lh-lg' : 'me-2'}${valueFirst ? ' order-2' : ''}`}>
        {label}
      </div>

      <div
        title={label}
        className={` d-flex justify-content-center align-items-center ${boldValue ? 'fw-bold' : 'fw-lighter'}${
          valueFirst ? ' order-1 me-2' : ''
        }`}
      >
        {icon && (
          <IconHandler
            Icon={icon}
            size={iconSize ? iconSize : centered ? '1.2rem' : '1rem'}
            className={classNames(centered && noText ? '' : 'me-1', mutedIcon ? 'text-muted' : '')}
          />
        )}
        {value}
      </div>
    </div>
  );
};

export default LabelValue;
